
// License.seasonMonths: the months a seasonal licence is expected to work, one bit a
// month (bit 0 January ... bit 11 December, 4095 all the year).
class SeasonMonths
{
    static readonly ALL = 4095;
    static readonly KEYS = [ "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER" ];

    static has( months:number, month:number ) : boolean {
        return ( months & ( 1 << month ) ) != 0;
    }

    static toggle( months:number, month:number ) : number {
        return months ^ ( 1 << month );
    }

    static count( months:number ) : number {
        let n = 0;
        for (let m = 0; m < 12; m++) if (SeasonMonths.has( months, m )) n++;
        return n;
    }

    static monthName( month:number ) : string {
        let key = SeasonMonths.KEYS[ month ];
        return MIOLocalizeString( key, key );
    }
}

class SeasonMonthCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set month(month:number){
        this.nameLabel.text = SeasonMonths.monthName( month );
    }
}

// Popover with the twelve months, a check mark on the ones the licence works.
// A tap switches a month on or off and tells onChange at once; at least one stays on.
class SeasonMonthsSelectViewController extends MUIViewController
{
    static newInstance() : SeasonMonthsSelectViewController {
        let vc = new SeasonMonthsSelectViewController("season-months-select-view");
        vc.initWithResource("layout/licenses/SeasonMonthsSelectView.html");
        return vc;
    }

    get preferredContentSize(): MIOSize {
        return new MIOSize(260, 480);
    }

    months:number = SeasonMonths.ALL;
    onChange:( months:number ) => void = null;

    private tableView:UITableView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return 1;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        return 12;
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("SeasonMonthCell") as SeasonMonthCell;
        cell.month = indexPath.row;
        cell.accessoryType = SeasonMonths.has( this.months, indexPath.row ) ? UITableViewCellAccessoryType.Checkmark : UITableViewCellAccessoryType.None;
        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let months = SeasonMonths.toggle( this.months, indexPath.row );
        if (months == 0) return;

        this.months = months;
        let cell = tableView.cellAtIndexPath( indexPath ) as SeasonMonthCell;
        cell.accessoryType = SeasonMonths.has( months, indexPath.row ) ? UITableViewCellAccessoryType.Checkmark : UITableViewCellAccessoryType.None;

        if (this.onChange != null) this.onChange( months );
    }
}
